import { createStyles, Grid, makeStyles } from '@material-ui/core';
import Home from '../../Home/Home';
import HomeHeaderMenu from '../../Home/HomeHeaderMenu';
import CoachHome from '../Coach/Coach_Home';
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme) =>
    createStyles({
        root: {
            position: 'sticky',
            left: 0,
            right: 0,
            zIndex: 1001,
            top: 0,
        },

    }),
);
function OrganizationHome() {
    const classes = useStyles();

  console.log(
    "initial",
    useSelector((state) => state.commonReducer)
  );

    return (
        <>
            <HomeHeaderMenu />
            <Grid xs={12}>
                <Home />
            </Grid>
        </>
    )
}

export default OrganizationHome
